import { Elements } from '@stripe/react-stripe-js';
// https://github.com/stripe/stripe-js/issues/43#issuecomment-614864800
import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe } from '@stripe/stripe-js/types';
import invariant from 'invariant';
import { FunctionComponent, ReactNode, useMemo } from 'react';

import { configValue } from 'config/appConfigUtils';

type Props = {
  children: ReactNode;
};

let globalStripePromise: Promise<Stripe | null> | undefined;

export function IdealistStripeProvider({ children }: Props) {
  const stripePromise = useMemo(() => {
    if (!globalStripePromise) {
      const publishableKey = configValue('stripe', 'publishableKey');
      invariant(publishableKey, 'Missing STRIPE_PUBLISHABLE_KEY');

      globalStripePromise = loadStripe(publishableKey);
    }

    return globalStripePromise;
  }, []);

  return <Elements stripe={stripePromise}>{children}</Elements>;
}

export function withIdealistStripeProvider<T>(Component: FunctionComponent<T>) {
  return function componentWithIdealistProvider(props: T) {
    return (
      <IdealistStripeProvider>
        {/* @ts-expect-error fix types */}
        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </IdealistStripeProvider>
    );
  };
}
